<template>
  <div id="order-status-report" class="content-wrapper">
    <section class="content w-100">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <b-row class="bg-white py-3">
          <b-col class="d-flex flex-column">
            <div slot="content">
              <div class="form-group col-md-3 col-sm-6 col-xs-12">
                <label>Chọn ngày</label>
                <date-range-picker
                  ref="picker"
                  v-model="dateRange"
                  :autoApply="true"
                  :locale-data="localeData"
                  :ranges="ranges"
                  :showDropdowns="true"
                  class="w-100"
                  opens="right"
                  @update="filter"
                >
                  <template v-slot:input="picker" style="min-width: 350px;">
                    {{ DDMMYYYY(picker.startDate) }} - {{ DDMMYYYY(picker.endDate) }}
                  </template>
                </date-range-picker>
              </div>
              <div class="form-group col-md-3 col-sm-6 col-xs-12">
                <label>Nhân viên chăm sóc</label>
                <multiselect id="ajax" v-model="filterData.pics" :clear-on-select="false"
                             :close-on-select="false" :disabled="disablePic"
                             :hide-selected="false" :internal-search="true" :limit="2"
                             :loading="loadingUser" :max-height="600" :multiple="true"
                             :options="groupUser" :options-limit="300" :searchable="true" :show-no-results="false"
                             select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                             group-label="label" group-values="users" :group-select="true"
                             label="name" open-direction="bottom"
                             placeholder="Nhập để tìm kiếm người dùng" track-by="code">
                </multiselect>
              </div>
            </div>
            <div class="ml-3">
              <b-button variant="success" @click="filter">
                <span aria-hidden="true" class="glyphicon glyphicon-search"></span>Tìm kiếm
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-table
            :fields="fields"
            :items="items"
            :busy="loading"
            bordered
            responsive
            sticky-header
          >
            <template #table-busy>
              <div class="text-center my-2 mt-5 mb-5">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Đang tải...</strong>
              </div>
            </template>
            <template #head(title)="scope">
              <div class="d-flex flex-column">
                <div class="text-nowrap p-2 border-top">
                  Trạng thái đơn hàng được xem
                </div>
                <div class="p-2 bg-aqua">
                  Tổng
                </div>
              </div>
            </template>
            <template #head()="scope">
              <div class="d-flex flex-column border-top" style="min-width: 150px">
                <div class="p-2 w-100 flex" style="background-color: #a3ce71; color: white">
                  {{ scope.label }}
                </div>
                <div class="p-2 w-100 bg-aqua text-center">
                  {{ getTotalOrderInDate(scope.label) }}
                </div>
              </div>
            </template>
            <template #cell()="data">
              <div v-if="data.field.key.toLowerCase() === 'title'" :class="data.item.level === 2 ? 'ml-5' : 'text-red text-bold'">
                {{ generateCell(data) }}
              </div>
              <div v-else class="text-center" :class="data.item.level === 1 ? 'text-red text-bold' : ''">{{ generateCell(data) }}</div>
            </template>
          </b-table>
        </b-row>
      </div>
    </section>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import ReportAPI from '../../api/report'
import Utils from '../../common/utils'
import UserApi from '../../api/user'
import {PERMISSION_KEY, MAX_SALE_USER_NUMBER} from '../../common/constant'
import {mapGetters} from 'vuex'
import {debounce} from 'lodash'

export default {
  name: 'ReportOrderStatus.vue',
  components: {
    DateRangePicker,
    Multiselect,
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    if (this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE)) {
      this.disablePic = true
      this.filterData.pics = [{code: this.userInfo.id, name: this.userInfo.username}]
    }
    let today = new Date()
    today.setHours(0, 0, 0, 0)

    let yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0)

    let sevenDaysAgo = new Date()
    sevenDaysAgo.setDate(today.getDate() - 7)
    sevenDaysAgo.setHours(0, 0, 0, 0)

    let thirtyDaysAgo = new Date()
    thirtyDaysAgo.setDate(today.getDate() - 30)
    thirtyDaysAgo.setHours(0, 0, 0, 0)

    this.ranges = {
      'Hôm nay': [today, today],
      'Hôm qua': [yesterday, yesterday],
      '7 ngày trước': [sevenDaysAgo, today],
      '30 ngày trước': [thirtyDaysAgo, today],
      'Tháng này': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0)],
      'Tháng trước': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
    }

    this.filterUser('')
  },
  created () {
    this.debounceUser = debounce(this.filterUser.bind(this), 500)
  },
  data () {
    return {
      company: null,
      ranges: null,
      localeData: {
        direction: 'ltr',
        format: 'mm/dd/yyyy',
        separator: ' - ',
        applyLabel: 'Chọn',
        cancelLabel: 'Huỷ',
        weekLabel: 'W',
        customRangeLabel: 'Tuỳ chọn',
        daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 0
      },
      dateRange: {
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month')
      },
      fields: [],
      total_row_items: {},
      filterData: {
        pics: []
      },
      items: [],
      users: [],
      groupUser: [],
      loadingUser: false,
      debounceUser: null,
      disablePic: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ])
  },
  methods: {
    filterUser (query) {
      this.loadingUser = true
      UserApi.findSaleByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })

        if (!this.disablePic) {
          this.filterData.pics = this.users
        }

        this.groupUser = [
          {
            label: 'Tất cả',
            users: this.users
          }
        ]
        this.loadingUser = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.title === 'Tổng') return 'bg-aqua'
    },
    DDMMYYYY (time) {
      return moment(time).format('DD/MM/YYYY')
    },
    YYYYMMDD (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getTotalOrderInDate (date) {
      if (date.toLowerCase() === 'tổng đơn hàng') {
        return this.total_row_items.total || 0
      }

      if (this.total_row_items.hasOwnProperty(date)) {
        return this.total_row_items[date]
      }

      return 0
    },
    generateCell (data) {
      if (data.field.key.toLowerCase() === 'tổng đơn hàng') {
        return data.item.total
      }

      if (data.item.hasOwnProperty(data.field.key)) {
        return data.item[data.field.key]
      }

      return 0
    },
    generateField (fields, startDate, endDate) {
      for (let i = startDate; i <= endDate; i = moment(i).add(1, 'days')) {
        fields.push(this.DDMMYYYY(i))
      }
    },
    buildFilterData (fromDate, toDate) {
      const filter = {
        from_date: fromDate,
        to_date: toDate,
        pics: []
      }

      if (this.filterData.pics.length > 0) {
        filter.pics = this.filterData.pics.map(item => item.code)
      }

      return filter
    },
    filter () {
      this.loading = true
      let startDate = this.YYYYMMDD(this.dateRange.startDate)
      let endDate = this.YYYYMMDD(this.dateRange.endDate)
      this.fields = [
        {key: 'title', stickyColumn: true, isRowHeader: true},
        'Tổng đơn hàng'
      ]
      this.generateField(this.fields, this.dateRange.startDate, this.dateRange.endDate)
      ReportAPI.filterOrderStatusReport(this.buildFilterData(startDate, endDate)).then(res => {
        this.loading = false
        this.items = res.data.data.report_by_status.map(item => {
          let new_format_item = {
            level: item.level,
            title: item.title,
            total: item.total,
          }
          item.records.map(record => {
            new_format_item[record.key] = record.value
          })
          return new_format_item
        })
        this.total_row_items = {}
        let total_order = 0
        res.data.data.report_by_date.map(item => {
          total_order += item.value
          this.total_row_items[item.key] = item.value
        })
        this.total_row_items['total'] = total_order

        console.log(this.items)
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#order-status-report {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/report/ReportOrderStatus.vue